import * as React from 'react';
export const IcBackgroundEffect = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M9 13c-3.31 0-6 2.69-6 6 0 1.11.89 2 2 2h8c1.1 0 2-.9 2-2 0-3.31-2.69-6-6-6zm0-1c1.93 0 3.5-1.57 3.5-3.5S10.93 5 9 5 5.5 6.57 5.5 8.5 7.07 12 9 12zm11.56-.09c-1.04-.3-1.17-.42-1.47-1.46a.612.612 0 00-1.18-.01c-.3 1.04-.42 1.17-1.46 1.47a.612.612 0 00-.01 1.18c1.04.3 1.17.42 1.47 1.46a.612.612 0 001.18.01c.3-1.04.42-1.17 1.46-1.47.26-.07.45-.32.45-.59 0-.27-.18-.51-.44-.59zM17 9c.29 0 .55-.19.63-.48.38-1.33.56-1.5 1.88-1.89.28-.08.48-.34.48-.63s-.19-.55-.48-.63c-1.33-.38-1.5-.56-1.89-1.89a.654.654 0 00-1.26.01c-.38 1.33-.56 1.5-1.88 1.89-.28.08-.48.34-.48.64s.2.55.48.63c1.33.38 1.51.56 1.89 1.89.08.28.34.47.63.47V9z'
      fill='currentColor'
    />
  </svg>
);
